import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatDialogModule } from '@angular/material/dialog';

export interface ConfirmationDialogData {
  title: string;
  message: string;
  confirmText?: string;
  cancelText?: string;
  icon?: string;
  iconColor?: string;
  confirmButtonColor?: 'primary' | 'accent' | 'warn';
  type?: 'info' | 'warning' | 'danger' | 'success';
}

@Component({
  selector: 'app-confirmation-dialog',
  standalone: true,
  imports: [
    CommonModule,
    MatButtonModule,
    MatIconModule,
    MatDialogModule
  ],
  templateUrl: './confirmation-dialog.component.html',
  styleUrl: './confirmation-dialog.component.scss'
})
export class ConfirmationDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<ConfirmationDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ConfirmationDialogData
  ) {
    // Set defaults
    this.data = {
      confirmText: 'Confirm',
      cancelText: 'Cancel',
      icon: 'help',
      iconColor: '#6b7280',
      confirmButtonColor: 'primary',
      type: 'info',
      ...this.data
    };

    // Set icon and color based on type
    if (this.data.type && !this.data.icon) {
      const typeConfig = this.getTypeConfig(this.data.type);
      this.data.icon = typeConfig.icon;
      this.data.iconColor = typeConfig.color;
      this.data.confirmButtonColor = typeConfig.buttonColor;
    }
  }

  private getTypeConfig(type: string) {
    const configs: { [key: string]: { icon: string; color: string; buttonColor: 'primary' | 'accent' | 'warn' } } = {
      info: {
        icon: 'info',
        color: '#3b82f6',
        buttonColor: 'primary'
      },
      warning: {
        icon: 'warning',
        color: '#f59e0b',
        buttonColor: 'accent'
      },
      danger: {
        icon: 'warning',
        color: '#ef4444',
        buttonColor: 'warn'
      },
      success: {
        icon: 'check_circle',
        color: '#10b981',
        buttonColor: 'primary'
      }
    };
    
    return configs[type] || configs['info'];
  }

  onConfirm(): void {
    this.dialogRef.close(true);
  }

  onCancel(): void {
    this.dialogRef.close(false);
  }
}
